// import Index from "views/Index.js";
import Profile from "views/Admin/Profile.js";
import Dashboard from "views/Admin/Dashboard";
import Login from "views/Admin/Login.js";
import Home from "views/users";
import Surevy from "views/users/survey";
import Contact from "views/users/contact";
import EducationalPage from "views/users/educational";
import FAQPage from "views/users/faq";
import BlogPage from "views/users/blog";
import Condition from "views/users/condition";
import MedicalCondition from "views/Admin/MedicalCondition";
import CreateMedicalCondition from "views/Admin/CreateMedicalCondition";
import SurveyResult from "views/Admin/SurveyResult";
import ContactUs from "views/Admin/ContactUs";
import Blogs from "views/Admin/Blogs";
import CreateBlog from "views/Admin/CreateBlog";
// import Category from "views/Admin/Category/Category";
import Education from "views/Admin/EducationalResources/Education";
import CreateEducation from "views/Admin/EducationalResources/CreateEducation";
import NewsLetter from "views/Admin/NewsLetter";
import Educational from "views/users/View More/Educational";
import Blog from "views/users/View More/Blog";
import Conditions from "views/users/View More/Conditions";
import FaqList from "views/Admin/FAQ/FaqList";
import CreateFaq from "views/Admin/FAQ/CreateFaq";
import Setting from "views/Admin/Setting/Setting";
// import UserList from "views/Admin/Users/User";
// import CreateUser from "views/Admin/Users/CreateUser";
import QuestionList from "views/Admin/QuestionList";
import EditQuestion from "views/Admin/EditQuestion";

import Sendmail from "views/Admin/SendMail";

var routes = [
  // {
  //   path: "/index",
  //   name: "Dashboard",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: <Index />,
  //   layout: "/admin",
  // },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    permission: "view-user",
  },
  // {
  //   path: "/users",
  //   name: "User",
  //   icon: "ni ni-circle-08 text-info",
  //   component: <UserList />,
  //   layout: "/admin",
  //   subRoutes: [
  //     {
  //       path: "create-user",
  //       name: "Create user",
  //       component: <CreateUser />,
  //     },
  //     {
  //       path: "edit-user/:id?",
  //       name: "Edit user",
  //       component: <CreateUser />,
  //     },
  //   ],
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/questions",
    name: "Questions",
    icon: "ni ni-collection text-blue", // pick any icon you like
    component: <QuestionList />,
    layout: "/admin",
    permission: "view-question",
    subRoutes: [
      {
        path: "edit-question/:id?",
        name: "Edit Question",
        component: <EditQuestion />,
      },
    ],
  },

  {
    path: "/medical-condition",
    name: "Medical Conditions",
    icon: "ni ni-bullet-list-67 text-red",
    component: <MedicalCondition />,
    layout: "/admin",
    permission: "view-medical-condition",
    subRoutes: [
      {
        path: "create-medical-condition",
        name: "Create Medical Condition",
        component: <CreateMedicalCondition />,
      },
      {
        path: "edit-medical-condition/:id?",
        name: "Edit Medical Condition",
        component: <CreateMedicalCondition />,
      },
    ],
  },
  {
    path: "/survey",
    name: "Survey",
    icon: "ni ni-paper-diploma text-success",
    component: <SurveyResult />,
    layout: "/admin",
    permission: "view-survey-result",
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    icon: "ni ni-email-83 text-info",
    component: <ContactUs />,
    layout: "/admin",
    permission: "view-contactus",
  },
  {
    path: "/blogs",
    name: "Blogs",
    icon: "ni ni-single-copy-04 text-primary",
    component: <Blogs />,
    layout: "/admin",
    permission: "view-blog",
    subRoutes: [
      {
        path: "create-blog",
        name: "Create Blog",
        component: <CreateBlog />,
      },
      {
        path: "edit-blog/:id?",
        name: "Edit Blog",
        component: <CreateBlog />,
      },
    ],
  },
  // {
  //   path: "/category",
  //   name: "Category",
  //   icon: "ni ni-folder-17 text-gray",
  //   component: <Category />,
  //   layout: "/admin",
  // },
  {
    path: "/faq",
    name: "FAQ",
    icon: "ni ni-chat-round text-info",
    component: <FaqList />,
    layout: "/admin",
    permission: "view-faq",
    subRoutes: [
      {
        path: "create-faq",
        name: "Create faq",
        component: <CreateFaq />,
      },
      {
        path: "edit-faq/:id?",
        name: "Edit faq",
        component: <CreateFaq />,
      },
    ],
  },
  {
    path: "/educational-resource",
    name: "Educational Resource",
    icon: "ni ni-books text-success",
    component: <Education />,
    layout: "/admin",
    permission: "view-educational-resources",
    subRoutes: [
      {
        path: "create-educational-resource",
        name: "Create Educational Resource",
        component: <CreateEducation />,
      },
      {
        path: "edit-educational-resource/:id?",
        name: "Edit Educational Resource",
        component: <CreateEducation />,
      },
    ],
  },
  {
    path: "/newsletter",
    name: "News Letter",
    icon: "ni ni-send text-primary",
    component: <NewsLetter />,
    layout: "/admin",
    permission: "view-newsletter",
  },
  {
    path: "/sendmail",
    name: "Send Mail",
    icon: "ni ni-send text-primary",
    component: <Sendmail />,
    layout: "/admin",
    permission: "send-email",
  },
  {
    path: "/setting",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-gray",
    component: <Setting />,
    layout: "/admin",
    permission: "view-settings",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/home",
    name: "Home",
    icon: "ni ni-key-25 text-info",
    component: <Home />,
    layout: "/user",
  },
  {
    path: "/survey",
    name: "A-Tool© Survey",
    icon: "ni ni-key-25 text-info",
    component: <Surevy />,
    layout: "/user",
  },
  {
    path: "/conditions",
    name: "Conditions",
    icon: "ni ni-key-25 text-info",
    component: <Condition isPagination={true} />,
    layout: "/user",
    subRoutes: [
      {
        path: "view-conditions/:id?",
        name: "view Conditions",
        component: <Conditions isPagination={true} />,
      },
    ],
  },
  {
    path: "/educational-info",
    name: "axSpA Education",
    icon: "ni ni-key-25 text-info",
    component: <EducationalPage isPagination={true} />,
    layout: "/user",
    subRoutes: [
      {
        path: "view-educational-resource/:id?",
        name: "view Educational Resource",
        component: <Educational />,
      },
    ],
  },
  {
    path: "/blogs",
    name: "What’s new",
    icon: "ni ni-key-25 text-info",
    component: <BlogPage isPagination={true} />,
    layout: "/user",
    subRoutes: [
      {
        path: "view-blogs/:id?",
        name: "view Blogs",
        component: <Blog />,
      },
    ],
  },
  {
    path: "/faq",
    name: "FAQ",
    icon: "ni ni-key-25 text-info",
    component: <FAQPage />,
    layout: "/user",
  },
  {
    path: "/contact",
    name: "Contact Us",
    icon: "ni ni-key-25 text-info",
    component: <Contact />,
    layout: "/user",
  },
];
export default routes;
